<template>
	<div class="price-card" :class="{ narrow, promotion: promotion && color }">
		<div class="logo" @click="$emit('logoClick')">
			<!-- <img :src="logo" alt="" /> -->
			<v-menu open-on-hover top v-if="controls">
				<!-- v-model="value"
			:disabled="disabled"
			:absolute="absolute"
			:open-on-hover="openOnHover"
			:close-on-click="closeOnClick"
			:close-on-content-click="closeOnContentClick"
			:offset-x="offsetX"
			:offset-y="offsetY" -->
				<template v-slot:activator="{ on }">
					<img :src="logo" v-on="on" alt="" />
				</template>
				<div class="pop-menu d-flex">
					<v-btn class="ml-2 erase" small @click="promotion = !promotion"><v-icon>mdi-flash</v-icon></v-btn>
					<v-btn class="ml-2 erase" small @click="$emit('remove')"> <v-icon>mdi-delete</v-icon></v-btn>
					<!-- <v-list-item-title @click="$emit('remove')">DELETE</v-list-item-title>
					<v-list-item-title @click="promotion = !promotion">PROMO</v-list-item-title> -->
				</div>
			</v-menu>
			<img v-else :src="logo" v-on="on" alt="" />
		</div>
		<div class="top">
			<input type="text" placeholder="type" v-model="card.type" class="type" :class="{ color: color }" />
			<textarea
				rows="1"
				@input="textareaFix"
				type="text"
				ref="title"
				placeholder="title"
				v-model="card.title"
				class="title-card"
				:class="{ color: color }"
				@focus="textareaFocus"
				data-name="title"
			/>
			<textarea
				@input="textareaFix"
				type="text"
				ref="description"
				placeholder="description"
				rows="2"
				v-model="card.description"
				class="description"
				@focus="textareaFocus"
				v-if="!twoLinesTitle"
				:data-content="card.description ? '' : 'empty'"
			/>
			<input type="text" placeholder="manufactor" v-model="card.manufactor" class="manufactor" />
		</div>
		<div class="bottom" :class="{ promo: card.promo }">
			<div class="bottom-left">
				<input
					type="text"
					ref="price"
					placeholder="price"
					v-model="card.price"
					class="price"
					:class="{ color: color }"
					@blur="pricefix"
				/>
			</div>
			<div class="bottom-right">
				<div class="bottom-line">
					<input
						type="text"
						placeholder="price-description"
						v-model="card.priceDescription"
						class="price-description"
					/>
				</div>
				<div class="bottom-line" v-if="general">
					<input type="text" @input="inputFix" placeholder="01.01.2018" v-model="card.date" class="date" />
					<input type="text" placeholder="seller" v-model="card.seller" class="seller" />
				</div>
				<div v-else>
					<input type="text" placeholder="seller" v-model="dateseller" class="seller" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import logoBw from '../assets/logo_RB.svg'
import logoColor from '../assets/logo_RB-color.svg'

export default {
	name: 'price-card',
	components: {},
	props: {
		card: {
			type: Object,
			required: true,
		},
		general: Boolean,
		color: Boolean,
		narrow: Boolean,
		controls: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		localDateSeller: '',
		twoLinesTitle: false,
		promotion: false,
	}),
	computed: {
		dateseller: {
			set(value) {
				this.localDateSeller = value
			},
			get() {
				if (this.localDateSeller) return localDateSeller
				else {
					return this.card.date + ' ' + this.card.seller
				}
			},
		},
		logo() {
			return this.color ? logoColor : logoBw
		},
	},
	watch: {
		card: {
			handler: function() {
				this.$emit('edit', this.card)
			},
			deep: true,
		},
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			this.textareaFix({ target: this.$refs.title })
			this.textareaFix({ target: this.$refs.description })
			this.pricefix()
		})
	},
	methods: {
		textareaFix(e) {
			e.target.style.height = '13px'
			e.target.style.height = e.target.scrollHeight + 'px'
			// console.log(e.target.scrollHeight)
			// console.log(e.target.style)
			// console.log(e)
			if (e.target.dataset.name == 'title') this.twoLinesTitle = e.target.scrollHeight > 30
		},
		inputFix(e) {
			e.target.style.width = ''
			e.target.style.width = e.target.value.length + 'ch'
			// e.target.style.height = e.target.scrollHeight + 'px'
			// console.log(e.target.scrollHeight)
			// this.twoLinesTitle = e.target.scrollHeight > 30
		},
		pricefix() {
			if (this.card.price) {
				let val = this.card.price
					.replace(/₽$/, '')
					.replace(/\s/g, '')
					.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
				this.card.price = val + ' ₽'
			}
		},
		textareaFocus(e) {
			e.target.select()
		},
	},
}
</script>

<style lang="scss" scoped>
.price-card {
	font-family: 'Gilroy' !important;
	background-color: #fff;
	position: relative;
	width: 224px;
	height: 149px;
	max-height: 149px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border: 1px solid #e9e9ea;

	input,
	textarea {
		font-family: 'Gilroy' !important;
		color: inherit;
		padding: 0;
		border: none;
		background-color: transparent;
		display: block;
		&:focus {
			outline: none;
		}
		@media print {
			&::placeholder {
				color: transparent !important;
			}
		}
		.bottom-right {
			flex: 1;
			display: flex;
			flex-direction: column;
		}
	}
	textarea {
		resize: none;
	}
	.type {
		font-weight: 800;
		font-size: 11px;
		line-height: 13px;
	}
	.title-card {
		font-weight: 800;
		font-size: 18px;
		line-height: 22px;
		text-transform: uppercase;
		margin-bottom: 2px;
		overflow: hidden;
	}
	.type.color,
	.title-card.color,
	.title.color {
		color: #4e367c;
	}
	.description,
	.manufactor {
		font-weight: 300;
		font-size: 11px;
		line-height: 13px;
	}
	.price {
		font-weight: 800;
		font-size: 24px;
		line-height: 29px;
		&.color {
			color: #24b8eb;
		}
	}
	.price-description,
	.date,
	.seller {
		font-weight: 300;
		font-size: 6.5px;
		line-height: 8.5px;
		width: 100%;
	}
	.price-description {
		width: 100%;
	}
	.logo {
		position: absolute;
		top: 10px;
		right: 12px;
	}
	.top {
		padding: 16px 9px 9px 12px;
		display: flex;
		flex-direction: column;
		height: 111px;
		overflow: hidden;
		* {
			flex-shrink: 0;
		}
	}
	.bottom {
		display: flex;
		align-items: center;
		background-color: #e9e9ea;
		// background-color: yellow;
		padding: 7px 6px 10px 12px;
		&.promo {
			background-color: #4e367c;
		}
	}
	.bottom-left {
		flex: 1 0 50%;
	}
	.bottom-right {
		flex: 1 50%;
		display: flex;
		flex-direction: column;
	}
	.bottom-line {
		display: flex;
		margin-bottom: 2px;
		// justify-content: space-between;
	}
	.price {
		width: 100%;
	}
	.date {
		width: 40px;
	}

	&.narrow {
		width: 111px;
		.top {
			padding-left: 9px;
			padding-right: 3px;
		}
		.description {
			display: none;
		}
		.bottom {
			flex-direction: column;
			align-items: flex-start;
		}
		.bottom-right {
			flex: unset;
			width: 100%;
		}
		.seller {
			font-size: 6.5px;
		}
	}

	&.narrow {
		width: 111px;
		.description {
			display: none;
		}
		.title-card {
			line-height: 1;
			margin-bottom: 0;
		}
		.bottom {
			padding: 7px 6px 10px 12px;
		}
		.price-description {
			width: auto;
		}
	}

	&.promotion {
		.bottom {
			background-color: #4e367c;
			.price-description,
			.date,
			.seller {
				color: #24b8eb;
			}
		}
	}

	@media print {
		[data-content='empty'] {
			display: none;
		}
	}
}
</style>
